// PrintButton.tsx
import React from 'react'

export function PrintButton({ onCapture }: { onCapture?: () => void }) {
  return (
    <button className="btn btn-sm" onClick={() => onCapture?.()}>
      Export
    </button>
  )
}
